<script lang="ts">
  import { onMount } from 'svelte';
  import { DESKTOP_TEXT_ALIGNMENT } from '$lib/constants/constants';
  import { richTextFormatter } from '$lib/helpers/richTextHelper';

  export let content;
  export let desktopTextAlignment: string | undefined = DESKTOP_TEXT_ALIGNMENT.LEFT;
  export let color: string | undefined = 'text-gray-600';

  let textAlignment: string = '';
  export let contentAnchor;

  $: switch (desktopTextAlignment) {
    case DESKTOP_TEXT_ALIGNMENT.CENTER:
      textAlignment =
        'mx-auto text-center w-fit [&>ul]:self-center [&>ol]:self-center items-center';
      break;
    case DESKTOP_TEXT_ALIGNMENT.LEFT:
      textAlignment = 'text-left items-start w-full';
      break;
  }

  //Add some extra semantic stuff to tables to help with nicer display
  onMount(async () => {
    let tables = document.querySelectorAll(
      '[data-content-component=rich-text] table:not([data-prettified])',
    );

    tables.forEach((table) => {
      let body = table.querySelector('tbody');
      let rows = table.querySelectorAll('tr');
      let headers: string[] = [];

      rows.forEach((row, i) => {
        let ths = row.querySelectorAll('th');
        let tds = row.querySelectorAll('td');

        if (i === 0 && tds.length === 0) {
          //This is the header row - let's extract it to a thead
          let thead = document.createElement('thead');
          let headerRow = document.createElement('tr');

          ths.forEach((th) => {
            let newTh = document.createElement('th');
            newTh.innerHTML = th.innerHTML;
            //Stash the text content of the header cell for later
            headers.push(th.innerText);
            headerRow.appendChild(newTh);
          });

          thead.appendChild(headerRow);
          table.insertBefore(thead, body);
          body.removeChild(row);
        }

        if (tds.length > 0) {
          //This is a data row - let's add some semantic stuff
          tds.forEach((td, j) => {
            //The first cell might be a header cell, if it only contains a strong tag and no other child nodes.
            //Swap it out for a th with scope=row
            if (j === 0 && td.querySelector('strong') && td.childNodes.length === 1) {
              let newTh = document.createElement('th');
              newTh.innerHTML = td.innerHTML;
              newTh.setAttribute('scope', 'row');
              row.replaceChild(newTh, td);
            }

            //Set some data-attributes on the cells to help with styling
            td.setAttribute('data-column-heading', headers[j]);
          });
        }
      });

      //Mark the table as having been prettified
      table.setAttribute('data-prettified', 'true');
    });
  });
</script>

<section class="w-full flex justify-center" data-content-component="rich-text">
  <div
    class="flex flex-col justify-center {textAlignment} gap-3 scroll-mt-[4.5rem] sm:scroll-mt-[5.875rem]"
    id={contentAnchor}
  >
    {@html richTextFormatter(content, color)}
  </div>
</section>
